export const LOGIN_FORM = 'login';
export const REGISTER_FORM = 'register';
export const PROFILE_FORM = 'profile';
export const FORGOT_PASSWORD_FORM = 'forgot_password';
export const MAGIC_LINK_HANDLER = 'magic_link_handler';
export const PAGE_ONLY_FOR_SIGNED_IN = 'only_signed_in';

export const DELETE_ACCOUNT_CONFIRMATION_MODAL =
  'delete_account_confirmation_modal';

export const URL_MODE_PARAM_NAME = 'mode';
export const URL_OOBCODE_PARAM_NAME = 'oobCode';
export const URL_SUCCESSFUL_SIGN_UP_PARAM_NAME = 'successfulSignUp';
export const URL_SUCCESSFUL_SIGN_IN_PARAM_NAME = 'successfulSignIn';
